const zeroPadded = (number) => (number > 9 ? number : "0" + number)

export const formattedDuration = (duration) => {
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)

  return zeroPadded(minutes) + ":" + zeroPadded(seconds)
}
